import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListDropDownComponent } from '@src/suite/common/components/list-drop-down/list-drop-down';
import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';
import { TeamMembersActions } from '@src/suite/common/store/team-members/team-members.actions';
import { selectTeamMembersGroupByField, selectTeamMembersSortByField } from '@src/suite/common/store/team-members/team-members.selectors';

import { BaseViewOptionsComponent } from '../base-view-options.component';

@Component({
    selector: 'st-manage-team-members-view-options',
    imports: [ListDropDownComponent, MatButtonToggleModule, MatListModule, MatMenuModule, MatTooltipModule],
    templateUrl: './manage-team-members-view-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-manage-team-members-view-options',
    },
})
export class ManageTeamMembersViewOptionsComponent extends BaseViewOptionsComponent implements OnInit {
    public predefineFilters: Record<string, LookupValue[]>;

    readonly sortByField = this.store.selectSignal(selectTeamMembersSortByField);
    readonly groupByField = this.store.selectSignal(selectTeamMembersGroupByField);

    public ngOnInit() {
        this.predefineFilters = {
            sorting: [
                { id: PSTFieldNames.UserInfoID, title: this.languageSettings.PSTWebUserGroupSortByIDLabel },
                { id: PSTFieldNames.UserInfoProgram, title: this.languageSettings.PSTWebUserGroupSortByProgramLabel },
                { id: PSTFieldNames.UserInfoGivenName, title: this.languageSettings.PSTWebUserGroupSortByFirstNameLabel },
                { id: PSTFieldNames.UserInfoSurname, title: this.languageSettings.PSTWebUserGroupSortByLastNameLabel },
                { id: PSTFieldNames.UserInfoRole, title: this.languageSettings.PSTWebUserGroupSortByRoleLabel },
                { id: PSTFieldNames.UserInfoEmail, title: this.languageSettings.PSTWebUserGroupSortByEmailLabel },
                { id: PSTFieldNames.UserInfoStatus, title: this.languageSettings.PSTWebUserGroupSortByStatusLabel },
            ],
        };
    }

    public setSortByField(v: any) {
        if (v !== this.sortByField()) {
            this.store.dispatch(TeamMembersActions.setSortByField({ field: v }));
        }
    }
}
